var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod from '@wix/ambassador-restaurants-fulfillments-v3-fulfillment-method/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var FulfillmentMethodType;
(function (FulfillmentMethodType) {
    /** Missing type due to an error */
    FulfillmentMethodType["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    /** Pickup */
    FulfillmentMethodType["PICKUP"] = "PICKUP";
    /** Delivery */
    FulfillmentMethodType["DELIVERY"] = "DELIVERY";
    /** DineIn */
    FulfillmentMethodType["DINE_IN"] = "DINE_IN";
})(FulfillmentMethodType || (FulfillmentMethodType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MON"] = "MON";
    DayOfWeek["TUE"] = "TUE";
    DayOfWeek["WED"] = "WED";
    DayOfWeek["THU"] = "THU";
    DayOfWeek["FRI"] = "FRI";
    DayOfWeek["SAT"] = "SAT";
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
export var Type;
(function (Type) {
    Type["UNDEFINED"] = "UNDEFINED";
    Type["RADIUS"] = "RADIUS";
    Type["POSTAL_CODE"] = "POSTAL_CODE";
    Type["CUSTOM"] = "CUSTOM";
})(Type || (Type = {}));
export var TimeDisplayUnit;
(function (TimeDisplayUnit) {
    TimeDisplayUnit["UNDEFINED"] = "UNDEFINED";
    TimeDisplayUnit["MINUTES"] = "MINUTES";
    TimeDisplayUnit["HOURS"] = "HOURS";
    TimeDisplayUnit["DAYS"] = "DAYS";
})(TimeDisplayUnit || (TimeDisplayUnit = {}));
export var BestDeliveryByCategory;
(function (BestDeliveryByCategory) {
    /** minimum delivery fee */
    BestDeliveryByCategory["DELIVERY_FEE"] = "DELIVERY_FEE";
})(BestDeliveryByCategory || (BestDeliveryByCategory = {}));
const _createFulfillmentMethodRequest = {};
const _createFulfillmentMethodResponse = {};
const _deleteFulfillmentMethodRequest = {};
const _deleteFulfillmentMethodResponse = {};
const _findBestDeliveryAreaRequest = {};
const _findBestDeliveryAreaResponse = {};
const _getFulfillmentMethodRequest = {};
const _getFulfillmentMethodResponse = {};
const _listFulfillmentMethodsRequest = {};
const _listFulfillmentMethodsResponse = {};
const _updateFulfillmentMethodRequest = {};
const _updateFulfillmentMethodResponse = {};
/**
 * Creates a new FulfillmentMethod
 * @param fulfillmentMethod - FulfillmentMethod to be created
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethod
 * @requiredField fulfillmentMethod.restaurantLocationId
 * @adminMethod
 * @returns The created FulfillmentMethod
 */
export function createFulfillmentMethod(fulfillmentMethod) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethod: '$[0]' };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createFulfillmentMethodResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethod]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.createFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethod',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get a FulfillmentMethod by id
 * @param fulfillmentMethodId - Id of the FulfillmentMethod to retrieve
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethodId
 * @returns The retrieved FulfillmentMethod
 */
export function getFulfillmentMethod(fulfillmentMethodId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethodId: '$[0]' };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFulfillmentMethodResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethodId]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.getFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethodId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update a FulfillmentMethod, supports partial update
 * @param _id - Fulfillment Id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField fulfillmentMethod
 * @adminMethod
 * @returns The updated FulfillmentMethod
 */
export function updateFulfillmentMethod(_id, fulfillmentMethod, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fulfillmentMethod: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFulfillmentMethodResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, fulfillmentMethod, options]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.updateFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'fulfillmentMethod',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Delete a FulfillmentMethod
 * @param fulfillmentMethodId - Id of the FulfillmentMethod to delete
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethodId
 * @adminMethod
 */
export function deleteFulfillmentMethod(fulfillmentMethodId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethodId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteFulfillmentMethodResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethodId]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.deleteFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethodId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * List Fulfillment Methods
 * @internal
 * @documentationMaturity preview
 */
export function listFulfillmentMethods(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            restaurantLocationIds: '$[0].restaurantLocationIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listFulfillmentMethodsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listFulfillmentMethodsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#fulfillmentMethods']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.listFulfillmentMethods(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Find the best delivery area for a geocoded order address
 * @internal
 * @documentationMaturity preview
 */
export function findBestDeliveryArea(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            restaurantLocationId: '$[0].restaurantLocationId',
            geocode: '$[0].geocode',
            orderAmount: '$[0].orderAmount',
            deliveryTime: '$[0].deliveryTime',
            bestDeliveryByCategory: '$[0].bestDeliveryByCategory',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _findBestDeliveryAreaRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _findBestDeliveryAreaResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsFulfillmentsV3FulfillmentMethod.findBestDeliveryArea(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-fulfillments-v3-fulfillment-method.universal.js.map